// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._37VgK6EhPJ-KgO {\n  margin-bottom: 0;\n}\n._2zeesWPnVcTY3K {\n  font-size: 12px;\n  line-height: 16px;\n  padding: 0 4px;\n  border-radius: 2px;\n  margin: auto 0 auto 8px;\n}\n._2zeesWPnVcTY3K._1qvbIuiU-cVhhq {\n  color: #FFFFFF;\n  background-color: #61BD4F;\n}\n._2zeesWPnVcTY3K._1Lu0RlIkbcTWDN {\n  color: #172B4D;\n  background-color: #F2D600;\n}\n._2zeesWPnVcTY3K._2coMJEJF-jLXt6 {\n  color: #FFFFFF;\n  background-color: #EC9488;\n}\n._2zeesWPnVcTY3K._32vINhUdLrCC42 {\n  color: #FFFFFF;\n  background-color: #EB5A46;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "_37VgK6EhPJ-KgO",
	"dueDateStatusLozenge": "_2zeesWPnVcTY3K",
	"is-due-complete": "_1qvbIuiU-cVhhq",
	"is-due-soon": "_1Lu0RlIkbcTWDN",
	"is-due-past": "_2coMJEJF-jLXt6",
	"is-due-now": "_32vINhUdLrCC42"
};
export default ___CSS_LOADER_EXPORT___;
